import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { CompanyService } from 'app/company/services/company.service';
import { CompanyListModel } from 'app/company/models/company-list.model';
import { CompanyTypeModel } from 'app/company/models/company-type-model';
import { AggregatorModel } from 'app/company/models/aggregator-model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Result } from 'app/core/models/result';
import { Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common';

@Component({
    selector: 'app-add-company',
    templateUrl: './add-company.component.html',
    styleUrls: ['./add-company.component.css']
})
export class AddCompanyComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    companies: CompanyListModel[];
    companyTypesList: CompanyTypeModel[];
    companiesList: CompanyListModel[];
    aggregatorsList: AggregatorModel[];
    submitAttempt: boolean = false;
    addCompanyFormGroup: FormGroup;
    dateNow: Date = new Date();

    constructor(
        private companyService: CompanyService,
        private fb: FormBuilder,
		private location: Location,
        private router: Router,
        private datePipe: DatePipe
    ) {
    }

    ngOnInit() {
        this.headerTitle = {
            title: 'Add Company', breadcrumbs: [
                { title: 'Companies', url: ['/company'] }
            ]
        }

        this.initializeForm();

        this.companyService.getCompanyTypes().subscribe(
            result => {
                this.companyTypesList = result;
            },
            error => {
                this.errors = error.errorList;
            }
        );
        this.companyService.getAll().subscribe(
            result => {
                this.companiesList = result;
            },
            error => {
                this.errors = error.errorList;
            }
        );
        this.companyService.getAggregators().subscribe(
            result => {
                this.aggregatorsList = result;
            },
            error => {
                this.errors = error.errorList;
            }
        );
    }

    initializeForm(): void {
        this.addCompanyFormGroup = this.fb.group(
            {
                legalName: ['', Validators.required],
                tradingName: [''],
                abn: [''],
                acn: [''],
                phoneNr: [''],
                mobileNr: [''],
                faxNr: [''],
                website: [''],
                notes: [''],
                hasLogo: [false, Validators.required],
                isActive: [false, Validators.required],
                companyTypeId: [2, Validators.required],
                parentId: [null],
                parentFullAccess: [true],
                aggregatorId: [null],
                aclNr: ['', Validators.required],
                acrNr: ['', this.requiredIfValidator(() => this.addCompanyFormGroup.get('companyTypeId').value == 1)],
                aclExpiry: [''],
                piExpiry: [''],
                afcaExpiry: [''],
                usersNr: [0, Validators.min(1)]
            }
        );
    }

    requiredIfValidator(predicate) {
        return (formControl => {
            if (!formControl.parent) {
                return null;
            }
            if (predicate()) {
                return Validators.required(formControl);
            }
            return null;
        })
    }

    addCompany(): void {
        this.submitAttempt = true;
        if (this.addCompanyFormGroup.valid) {

            var aclExpiry = this.addCompanyFormGroup.get('aclExpiry').value;
            var piExpiry = this.addCompanyFormGroup.get('piExpiry').value;
            var afcaExpiry = this.addCompanyFormGroup.get('afcaExpiry').value;

            const formValue = this.addCompanyFormGroup.value;
            formValue.aclExpiry = aclExpiry ? new Date(new Date(aclExpiry).setHours(12)).toISOString() : null;
            formValue.piExpiry = piExpiry ? new Date(new Date(piExpiry).setHours(12)).toISOString() : null;
            formValue.afcaExpiry = afcaExpiry ? new Date(new Date(afcaExpiry).setHours(12)).toISOString() : null;

            this.companyService.create(formValue).subscribe(
                companyId => {
                    this.router.navigate(['./company/' + companyId]);
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }

    onBack(): void {
        this.location.back();
    }

    get legalName() { return this.addCompanyFormGroup.get('legalName'); }
    get aclNr() { return this.addCompanyFormGroup.get('aclNr'); }
    get acrNr() { return this.addCompanyFormGroup.get('acrNr'); }
    get abn() { return this.addCompanyFormGroup.get('abn'); }
    get usersNr() { return this.addCompanyFormGroup.get('usersNr'); }
}
